import { render, staticRenderFns } from "./jzuniqy.vue?vue&type=template&id=3beb3de8&scoped=true&"
import script from "./jzuniqy.vue?vue&type=script&lang=js&"
export * from "./jzuniqy.vue?vue&type=script&lang=js&"
import style0 from "./jzuniqy.vue?vue&type=style&index=0&id=3beb3de8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb3de8",
  null
  
)

export default component.exports